import { render, staticRenderFns } from "./WorkflowForm.vue?vue&type=template&id=65cb9b3f"
import script from "./WorkflowForm.vue?vue&type=script&lang=js"
export * from "./WorkflowForm.vue?vue&type=script&lang=js"
import style0 from "./WorkflowForm.vue?vue&type=style&index=0&id=65cb9b3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports